import React from 'react';
import styled from 'styled-components';
import Typography from '../common/typography/Typography';

// Badge styled component
const Badge = styled.div`
    margin:0 auto;
    display: inline-block;
    background-color: ${({ reverse }) => (reverse ? '#FFF' : '#F7F1FF')};
    color: #5B63F6;
 

    padding: 8px 20px;

    border-radius: 90px;

`;

// Section styled component
const SectionContainer = styled.section`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    padding: 10px 10px; 
    border-radius: 8px; 
`;

const SectionTitle = styled.h2`


    
`;

const SectionContent = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    @media (min-width: 600px) {
        padding-left: 56px;
        padding-right: 56px;
    }
    @media (min-width: 200px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

const Section = ({ badgeText, titleText, children, background = "#FFF", reverse = false }) => {
  return (
    <div style={{ background: background }}>
      <SectionContainer>
        <Badge reverse={reverse}>
          <Typography size="30px" weight="500">{badgeText}</Typography>
        </Badge>
        <SectionTitle>
          <Typography size="64px" weight="700" textAlign="center">{titleText}</Typography>
        </SectionTitle>
      </SectionContainer>
      <SectionContent>
        {children}
      </SectionContent>
    </div>
  );
};

export default Section;
